import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { MapPin, Phone, Clock, Star, MessageCircle } from 'lucide-react';
import { branches } from '../mock';

const Branches = () => {
  const handleWhatsAppClick = (whatsapp) => {
    window.open(`https://wa.me/${whatsapp}?text=Hi, I'd like to book an appointment at Mark's Barber`, '_blank');
  };

  const handleCallClick = (phone) => {
    window.location.href = `tel:${phone}`;
  };

  return (
    <section id="branches" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#0B0B0B] mb-4 font-playfair">Our Locations</h2>
          <div className="w-24 h-1 bg-[#C9A227] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">Visit any of our 5 premium locations across Selangor and Penang</p>
        </div>

        {/* Branches Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {branches.map((branch) => (
            <Card key={branch.id} className="overflow-hidden hover:shadow-2xl transition-all duration-300 border-0">
              <CardContent className="p-0">
                {/* Map */}
                <div className="h-64 bg-gray-200 relative overflow-hidden group">
                  <iframe
                    src={branch.mapUrl}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="group-hover:scale-105 transition-transform duration-500"
                  ></iframe>
                </div>

                {/* Content */}
                <div className="p-8 bg-white">
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <h3 className="text-2xl font-bold text-[#0B0B0B] mb-1 font-playfair">{branch.name}</h3>
                      <p className="text-sm text-gray-500 uppercase tracking-wide">{branch.state}</p>
                    </div>
                    <div className="flex items-center space-x-1 bg-[#C9A227] px-3 py-1 rounded-full">
                      <Star className="w-4 h-4 text-black fill-black" />
                      <span className="font-bold text-black">{branch.rating}</span>
                      <span className="text-xs text-black">({branch.reviews})</span>
                    </div>
                  </div>

                  <div className="space-y-4 mb-6">
                    <div className="flex items-start space-x-3">
                      <MapPin className="w-5 h-5 text-[#C9A227] flex-shrink-0 mt-1" />
                      <p className="text-gray-600">{branch.address}</p>
                    </div>
                    <div className="flex items-center space-x-3">
                      <Clock className="w-5 h-5 text-[#C9A227] flex-shrink-0" />
                      <p className="text-gray-600">{branch.hours}</p>
                    </div>
                    <div className="flex items-center space-x-3">
                      <Phone className="w-5 h-5 text-[#C9A227] flex-shrink-0" />
                      <p className="text-gray-600">{branch.phone}</p>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex flex-col sm:flex-row gap-3">
                    <Button
                      onClick={() => handleWhatsAppClick(branch.whatsapp)}
                      className="flex-1 bg-[#C9A227] hover:bg-[#B89220] text-black font-semibold transition-all duration-300 hover:scale-105"
                    >
                      <MessageCircle className="w-4 h-4 mr-2" />
                      Book via WhatsApp
                    </Button>
                    <Button
                      onClick={() => handleCallClick(branch.phone)}
                      variant="outline"
                      className="flex-1 border-2 border-[#0B0B0B] text-[#0B0B0B] hover:bg-[#0B0B0B] hover:text-white font-semibold transition-all duration-300"
                    >
                      <Phone className="w-4 h-4 mr-2" />
                      Call Now
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Branches;